/* eslint-disable react/no-multi-comp */
import PropTypes from 'prop-types'

import React from 'react'
import { FormattedMessage } from 'react-intl'

import {
    LineClamp,
    Tooltip,
    TooltipBody,
    TooltipSubtitle,
} from 'react-wot-bootstrap'

import { LINE_CLAMP_LINES } from '../constants.js'

export const DialogChangeRolePlayersTooltip = ({ children }) => (
    <Tooltip id={DialogChangeRolePlayersTooltip.id}>
        <TooltipBody>
            <TooltipSubtitle>
                <FormattedMessage
                    id="clanmanagement.tooltips.dialog_change_roles_players_header"
                    defaultMessage="Изменить должности игрокам:"
                />
            </TooltipSubtitle>
            <LineClamp lines={LINE_CLAMP_LINES}>{children}</LineClamp>
        </TooltipBody>
    </Tooltip>
)
DialogChangeRolePlayersTooltip.id = 'dialog-change-role-players-body'
DialogChangeRolePlayersTooltip.propTypes = {
    children: PropTypes.node.isRequired,
}

export const DialogChangeRoleSelectTooltip = () => (
    <Tooltip id={DialogChangeRoleSelectTooltip.id}>
        <TooltipBody>
            <TooltipSubtitle>
                <FormattedMessage
                    id="clanmanagement.tooltips.dialog_change_role_select_header"
                    defaultMessage="Новая должность"
                />
            </TooltipSubtitle>
            <FormattedMessage
                id="clanmanagement.tooltips.dialog_change_role_select_body"
                defaultMessage="Выберите должность, на которую будут назначены выбранные игроки."
            />
        </TooltipBody>
    </Tooltip>
)
DialogChangeRoleSelectTooltip.id = 'dialog-change-role-select-tooltip'



// WEBPACK FOOTER //
// ./containers/ClanManagement/components/Dialogs/ChangeRole/tooltips.js